WindowModalService.$inject = ['ModalService'];

export function WindowModalService(ModalService) {
  // let modalIsOpening; // for preventing double click - PROBLEMS WITH TWO MODALS

  let service = {
    open: openModal,
  };

  return service;

  //////////

  function openModal(templateUrl, modalParams, confirmCallback, cancelCallback) {
    // for preventing double click
    // if (modalIsOpening){ return; }
    // modalIsOpening = true;

    let modalInstance = ModalService.showModal({
      templateUrl: templateUrl,
      controller: ModalWindowCtrl,
      controllerAs: 'vm',
      inputs: {
        modalParams: modalParams,
        confirmCallback: confirmCallback,
        cancelCallback: cancelCallback,
      },

      // locationChangeSuccess: false // allows the closing of the modal when the location changes to be configured
      // TODO: willy - check this as some modals present issues with close callback
    });

    // Register confirm and cancel callbacks
    modalInstance.then(function (modal) {
      let preventModalClose = {
        backdrop: 'static', // added static to work
        keyboard: true,
      };

      if (modalParams.preventModalClose) {
        preventModalClose.backdrop = 'static';
        preventModalClose.keyboard = false;
      }

      modal.element.modal(preventModalClose);
    });

    ModalWindowCtrl.$inject = [
      'UtilService',
      'modalParams',
      'confirmCallback',
      'cancelCallback',
      '$element',
    ];
  }

  function ModalWindowCtrl(UtilService, modalParams, confirmCallback, cancelCallback, $element) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    // If specified, fill window parameters
    vm.modalId = modalParams.id || '';
    vm.modalMode = modalParams.mode || '';
    vm.modalWidth = modalParams.width || '';
    vm.modalPosition = modalParams.position || '';
    vm.modalTitle = modalParams.title || '';
    vm.modalBody = modalParams.body || '';
    vm.confirmButtonLabel = modalParams.confirmButtonLabel || 'OK';
    vm.cancelButtonLabel = modalParams.cancelButtonLabel || 'Cancel';

    vm.item = modalParams.item || {};

    vm.mode = modalParams.mode || '';

    vm.defaultLanguage = modalParams.defaultLanguage || '';
    vm.additionalLanguages = modalParams.additionalLanguages || {};

    vm.parentOptions = modalParams.parentOptions || {}; // Optional

    vm.additionalParams = modalParams.additionalParams || '';

    // public methods
    // -----------------------
    vm.onSavedItem = function (item) {
      let closeOnSave = modalParams.closeOnSave === false ? false : true;

      if (closeOnSave) {
        $element.modal('hide');
      }

      if (confirmCallback !== undefined) {
        //console.log('confirmCallback');
        confirmCallback(item);
      }
    };

    vm.onCanceledItem = function () {
      $element.modal('hide');

      if (cancelCallback && cancelCallback !== undefined) {
        //console.log('cancelCallback');
        cancelCallback();
      }
    };
  }
}
